/* eslint-disable no-barrel-files/no-barrel-files */
import { SEARCH_PARAM_COMPONENT_ID } from 'routes/(common_search_params)/-searchParams'
import {
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export { SEARCH_PARAM_COMPONENT_ID }

export const virtualReportDetailsSearchParams = z.object({
  [SEARCH_PARAM_SITE_ID]: z.string(),
  [SEARCH_PARAM_COMPONENT_ID]: z.string().catch(''),
})

export const createVirtualReportsSearch = ({
  orgId,
  siteId,
}: {
  orgId: string | undefined
  siteId: string | undefined
}) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})

export const createVirtualReportDetailsSearch = ({
  orgId,
  siteId,
  componentId,
}: {
  orgId: string | undefined
  siteId: string
  componentId: string
}) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
  [SEARCH_PARAM_COMPONENT_ID]: componentId,
})
